import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { styled } from '@linaria/react';
import { FacilitiesGrid } from 'components/Accommodation/Facilities';
import { showHotelFacilities } from 'modules/overlay/actions';
import { getHotelFacilitiesRanked, TOP_FACILITY_IDS } from 'utils/facilities';
import { ButtonLink } from '@daedalus/atlas/ButtonLink';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Text } from '@daedalus/atlas/Text';
import { useInView } from '@daedalus/core/src/_web/utils/browser/hooks/useInView';
import { useDispatchTeamEvent } from '@daedalus/core/src/analytics/components/TeamContext';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { ContentHotel } from '@findhotel/sapi/dist/types/packages/core/src';
import { MAXIMUM_POPULAR_FACILITIES } from './constants';
import { PopularFacilitiesLoading } from './PopularFacilitiesLoading';
interface Props {
  hotel: ContentHotel;
}
const _exp = /*#__PURE__*/() => ButtonLink;
const ShowMoreButton = /*#__PURE__*/styled(_exp())({
  name: "ShowMoreButton",
  class: "s10ouork",
  propsAsIs: true
});
export const PopularFacilities = ({
  hotel
}: Props) => {
  const dispatch = useDispatch();
  const dispatchTeamEvent = useDispatchTeamEvent();
  const {
    isMobile
  } = useDeviceLayout();
  const {
    ref,
    inView
  } = useInView({
    triggerOnce: true,
    threshold: 0.5
  });
  const onSeeMore = () => {
    dispatchTeamEvent(trackEvent({
      category: Category.User,
      entity: Entity.HotelDetailsSeeMoreFacilities,
      action: Action.Clicked
    }));
    dispatch(showHotelFacilities({
      hotelId: hotel.objectID
    }));
  };
  useEffect(() => {
    if (inView) {
      dispatchTeamEvent(trackEvent({
        category: Category.User,
        entity: Entity.HotelDetailsFacilitiesSection,
        action: Action.Viewed
      }));
    }
  }, [dispatchTeamEvent, inView]);
  if (!hotel?.facilities) return <PopularFacilitiesLoading />;
  const topFacilities = getHotelFacilitiesRanked(hotel.facilities, TOP_FACILITY_IDS, MAXIMUM_POPULAR_FACILITIES);
  const hasMore = hotel.facilities.length > MAXIMUM_POPULAR_FACILITIES;
  return <Flex.Column gap="s500">
      <Text variant="titleL">
        <FormattedMessageWrapper id="amenities" defaultMessage="Amenities" />
      </Text>
      <div ref={ref}>
        <FacilitiesGrid facilities={topFacilities} />
      </div>
      {hasMore && <ShowMoreButton onClick={onSeeMore} size={isMobile ? 'md' : 'lg'} variant="default" isCompact>
          <FormattedMessageWrapper id="showAll" defaultMessage="Show all" />
        </ShowMoreButton>}
    </Flex.Column>;
};

require("./PopularFacilities.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PopularFacilities.tsx");